export default "__VITE_ASSET__BOobpQl4__"